import React from 'react'
import PropTypes from 'prop-types'
import PortalModal from 'components/Shared/PortalModal'
import { Trans, useTranslation } from 'react-i18next'

import { SecondaryButton } from 'components/Shared/Button'
import { useCampaignConfig, useCampaignConfigDispatch } from './CampaignConfigProvider'
import { numberWithThousandsSeparators } from 'utils/helpers'

export function ErrorContent({ isOpen, onClose, onRetry }) {
  const { error } = useCampaignConfig()
  const { hasPermissionError } = useCampaignConfigDispatch()
  const { t } = useTranslation()

  if (!isOpen) {
    return null
  }

  const isPermissionError = hasPermissionError()
  const errorType = isPermissionError ? 'permissionError' : 'transientError'
  let key = `Recommendations.campaignConfig.error.${errorType}.description`
  let errorMsgData = {}

  if (error?.code === 'error.campaign.config.daily_budget.too_low') {
    key = 'Recommendations.campaignConfig.error.dailyBudgetTooLow.description'
    errorMsgData = { min: numberWithThousandsSeparators(error.data.min), currency: error.data.currency }
  }

  return (
    <div className="yes-no-prompt_content cbr-error-content">
      <Trans
        i18nKey={key}
        components={{
          a: (
            <a
              href="/settings#meta"
              rel="noopener noreferrer"
              target="_blank"
              className="d-inline-block"
              style={{ color: '#2F80ED' }}
            >
              Meta assets page
            </a>
          ),
        }}
        values={errorMsgData}
      />
      {isPermissionError ? (
        <SecondaryButton
          linkTo="/settings#meta"
          className="bt"
          color="orange"
          text={t('Recommendations.campaignConfig.error.permissionError.action')}
        />
      ) : onRetry ? (
        <SecondaryButton className="bt" text={t('common.tryAgain')} onClick={onRetry} color="orange" />
      ) : (
        <SecondaryButton className="bt" text={t('common.close')} onClick={onClose} color="orange" />
      )}
    </div>
  )
}

ErrorContent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
}

export default function ErrorModal({ isOpen, onClose, onRetry }) {
  const { t } = useTranslation()
  const { error } = useCampaignConfig()
  const { hasPermissionError } = useCampaignConfigDispatch()

  const errorType = hasPermissionError() ? 'permissionError' : 'transientError'
  let errorTitleKey = `Recommendations.campaignConfig.error.${errorType}.title`
  if (error?.code === 'error.campaign.config.daily_budget.too_low') {
    errorTitleKey = 'Recommendations.campaignConfig.error.dailyBudgetTooLow.title'
  }

  return (
    <PortalModal
      isOpen={isOpen}
      onClickOutside={onClose}
      title={t(errorTitleKey)}
      className="cbr-modal cbr-modal--error"
    >
      <div className="yes-no-prompt-prompt">
        <ErrorContent onClose={onClose} onRetry={onRetry} isOpen={isOpen} />
      </div>
    </PortalModal>
  )
}

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func,
}
